module.exports = __webpack_public_path__ + "static/media/tunnel_lane_closed.c0bd7872.png";